import Swiper from 'swiper'
import 'swiper/css/bundle'
import './style.scss'
import MobileTabMenu from '../../js/app/MobileTabMenu'

export default class Tabs {
	name = 'Tabs'

	constructor() {
		this.init = this.init.bind( this )
		this.nextClick = this.nextClick.bind( this )
		this.tabLinkClick = this.tabLinkClick.bind( this )
		this.slideChange = this.slideChange.bind( this )
	}

	init() {
		this.tabComponents = Array.from( document.querySelectorAll( '.block--yurika--tabs' ) )

		this.tabLinks = Array.from( document.querySelectorAll( '.block--yurika--tabs .mobile-tab-menu--tab-link' ) )

		this.tabLinks.forEach( tabLink => {
			tabLink.addEventListener( 'click', this.tabLinkClick )
		} )

		this.tabComponents.forEach( tabs => {
			const tabsContents = tabs.querySelector( '.tabs--tabs-contents' )
			if ( tabs.swiper ) tabs.swiper.destroy()

			tabs.swiper = new Swiper( tabsContents, {
				slidesPerView: 1,
				freeMode: false,
				shortSwipes: true,
				loop: true,
				on: {
					init: this.slideChange,
					realIndexChange: this.slideChange,
				},
			} )

			let slides = Array.from( tabsContents.querySelectorAll( '.swiper-slide' ) )

			slides.forEach( slide => {
				slide.addEventListener( 'click', this.slideChange )
			} )

			tabsContents.addEventListener( 'click', this.nextClick )

			tabs.mobileTabMenu = new MobileTabMenu( tabs )
			tabs.mobileTabMenu.init()
		} )
	}

	windowResizeHandler() {
		this.tabComponents.forEach( tabs => {
			tabs.mobileTabMenu.windowResizeHandler()
		} )
	}

	tabLinkClick( e ) {
		const container = e.target.closest( '.tabs--container' )
		const tabs = container.querySelector( '.tabs--tabs-contents' )
		if ( tabs.swiper ) tabs.swiper.slideTo( e.target.dataset.index )
		e.preventDefault()
	}

	slideChange( swiper ) {
		const tabs = swiper.el
		tabs.setAttribute( 'data-index', swiper.realIndex )
		const container = swiper.el.closest( '.tabs--container' )

		// clear all other active titles
		const titles = Array.from( container.querySelectorAll( '.mobile-tab-menu--tab-title' ) )
		for ( let title of titles ) {
			title.classList.remove( 'active' )
		}

		// and activate our current one
		const title = container.querySelector( `.mobile-tab-menu--tab-title:nth-child(${ swiper.realIndex + 1 })` )
		if ( title ) {
			title.classList.add( 'active' )
		}
	}

	slideChanged( swiper ) {
		const tabs = swiper.el
		setTimeout( () => {
			if ( swiper.realIndex == swiper.slides.length - 1 ) {
				hero.setAttribute( 'data-index', 'loop' )
			}
		}, 250 )
	}

	nextClick( e ) {
		const tabs = e.target.closest( '.swiper' )
		if ( tabs.swiper ) tabs.swiper.slideNext()
		e.preventDefault()
	}

	destroy() {
		this.tabComponents.forEach( tabs => {
			if ( tabs.swiper ) tabs.swiper.destroy()
			if ( tabs.titlesSwiper ) tabs.titlesSwiper.destroy()
		} )
		window.removeEventListener( 'resize', this.windowResize )
	}
}

window.app.addBlock( new Tabs() )
